import { useState } from "react";
import usePageMeta from "../hooks/usePageMeta";
import { canonicalUrl } from "../data/seo";
import { useBooks } from "../context/BooksContext";
import BookCard from "../components/BookCard";
import { Sparkles } from "lucide-react";

export default function Shop() {
  usePageMeta({
    title: "Shop the Books | Digsby Early Learning",
    description:
      "Browse workbooks and story books for ages 2 to 7 from Digsby Early Learning. Every title ships through Amazon.",
    canonical: canonicalUrl("/shop"),
  });

  const { books, categories } = useBooks();
  const [tab, setTab] = useState("All");
  const TABS = ["All", ...categories];
  const filtered = tab === "All" ? books : books.filter((b) => b.category === tab);

  return (
    <div className="bg-[#FFFBF2] min-h-screen">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 text-sm font-bold text-[#FF0000] uppercase tracking-wider">
            <Sparkles size={16} /> The Catalog
          </span>
          <h1 className="font-heading font-bold text-4xl sm:text-5xl mt-3 text-black">
            Shop the Books
          </h1>
          <p className="mt-4 text-lg text-slate-700">
            Every title is available on Amazon, which handles secure payment, printing,
            and shipping. Tap <strong>Buy on Amazon</strong> to purchase.
          </p>
        </div>

        {/* Filter tabs */}
        <div className="mt-10 flex flex-wrap justify-center gap-3" role="tablist" aria-label="Book categories">
          {TABS.map((t) => {
            const active = tab === t;
            return (
              <button
                key={t}
                role="tab"
                aria-selected={active}
                data-testid={`filter-tab-${t.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setTab(t)}
                className={`min-h-[48px] rounded-full px-6 font-heading font-bold text-base border-2 transition-all duration-200 ${
                  active
                    ? "bg-[#0000FF] text-white border-[#0000FF] shadow-md"
                    : "bg-white text-slate-700 border-black/15 hover:border-[#0000FF] hover:-translate-y-0.5"
                }`}
              >
                {t}
                {t !== "All" && (
                  <span className="ml-2 text-xs opacity-80">
                    ({books.filter((b) => b.category === t).length})
                  </span>
                )}
              </button>
            );
          })}
        </div>

        {/* Grid */}
        <div
          data-testid="book-grid"
          className="mt-12 grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
        >
          {filtered.map((book) => (
            <BookCard key={book.slug} book={book} />
          ))}
        </div>
      </section>
    </div>
  );
}
